/**
 * queue #689 §UAT-2026-07-14-R689 §R689-1-⑥ — 소비자 가이드 KO/EN 자산 선택 판정 SSOT.
 *
 * queue #686 §UAT-2026-07-14-R686 §R686-1-3 에서 `ConsumerGuidePage` 안에 인라인으로 있던
 * "EN 로케일 + EN 자산 유효(lang !== 'ko-fallback') 시에만 EN, 그 외 KO 폴백" 판정을 순수
 * 함수로 추출한다. `useSearchIndex`(#689 doc 검색 인덱스)와 `ConsumerGuidePage`가 **같은
 * 함수**를 호출해야 언어 판정이 어긋나지 않는다(판정 drift 방지).
 */
export interface ConsumerGuideAssetLike {
  lang?: 'en' | 'ko-fallback';
}

export interface ResolvedConsumerGuideAsset<T> {
  asset: T;
  useEnGuide: boolean;
}

/**
 * `language`(i18n.language) 가 `en` 으로 시작하고 `enAsset.lang !== 'ko-fallback'` 일 때만
 * EN 자산을 선택한다. 그 외에는(EN 로케일이 아니거나, EN 번역이 아직 없어 extract 스크립트가
 * KO 를 복제해 채운 `ko-fallback` 산출물이면) KO 로 폴백한다.
 */
export function resolveConsumerGuideAsset<T extends ConsumerGuideAssetLike>(
  language: string,
  koAsset: T,
  enAsset: T
): ResolvedConsumerGuideAsset<T> {
  const useEnGuide = language.startsWith('en') && enAsset.lang !== 'ko-fallback';
  return { asset: useEnGuide ? enAsset : koAsset, useEnGuide };
}
